<template>
    <div>
        <div v-if="ativo_pai.qt_us == 0">
            <img :src="ativo_pai.nm_caminho_imagem" alt="">
        </div>
        <div v-show="show_add_ativo">
            <DxSelectBox
                placeholder="Ativo"
                :data-source="ativos_select"
                v-model="cd_ativo"
                display-expr="nm_item_serial"
                value-expr="cd_ativo"
                search-mode="contains"
                search-expr="nm_item_serial"
                :search-enabled="true"
                @value-changed="onChangeAtivo"
            />
            <br>
            <DxNumberBox
                placeholder="Posição inicial"
                v-model="cd_item_u"
                :show-spin-buttons="true"
                :show-clear-button="true"
                :min="0"
            />
            <br>
            <DxButton 
                icon="check" 
                type="success" 
                text="Adicionar" 
                @click="adicionar_ativo"/>
        </div>
        <!--div v-html-->
        <div v-show="show_rack && load && ativo_pai.qt_us != 0" style="overflow-x: auto; position: relative;">
            <!--LÂMINA SEM POSIÇÃO-->
            <div v-for="lamina in laminas_rack" v-bind:key="lamina">
                <div
                    class="draggable"
                    :style="{
                      top: lamina.vl_top + 'px',
                      left: lamina.vl_left + 'px',
                      width: lamina.vl_width + 'px',
                      height: lamina.vl_height + 'px',
                      position: 'absolute',
                      backgroundImage: 'url(' + lamina.nm_caminho_imagem.replaceAll(' ', '%20') + ')',
                      zIndex: 9999
                    }"
                    @click="click_ativo(lamina)">
                </div>
            </div>
            <div
                v-if="ativo_lamina"
                class="draggable"
                :style="{
                  top: position.y + 'px',
                  left: position.x + 'px',
                  width: size.width + 'px',
                  height: size.height + 'px',
                  position: 'absolute',
                  backgroundImage: 'url(' + ativo_lamina[0].nm_caminho_imagem.replaceAll(' ', '%20') + ')',
                }"
                @mousedown="startDrag">
                <div class="resize-handle" @mousedown.stop.prevent="startResize"></div>
            </div>
            <div class="divs">
                <div class="div-rack" :style="{height: ativo_pai.qt_us*15.6 + 'px'}">
                    <div class="rack">
                        <div v-for="(ativo) in ativos_hack" v-bind:key="ativo">
                            <div v-if="ativo.u != undefined" class="rack_item"></div>
                            <div v-else class="rack_item_imagem"><img :height="((ativo.qt_us==1?ativo.qt_us:ativo.qt_us)*15) + 'px'" width="170px" :src="ativo.nm_caminho_imagem" alt="" @click="click_ativo(ativo)"></div>
                        </div>
                    </div>
                    <div class="racknum">
                        <div v-for="i in posicoes" v-bind:key="i">
                            <div class="rack_num">{{ i }}</div>
                        </div>
                    </div>
                </div>
                <div class="space_tabela">
                    <table class="tabela">
                        <tr><th>DESCRIÇÃO</th><th>N. SÉRIE</th><th>TAG</th><th>CHAVE</th><th>POSIÇÃO</th><th>OBSERVAÇÃO</th><th>REMOVER</th><th>ID</th></tr>
                        <tr v-for="element in ativos.filter((a)=> a.cd_tipo_item != 5 && a.cd_tipo_item != 6)" v-bind:key="element">
                            <td>{{element.nm_descricao}}</td><td>{{element.nm_serial_number}}</td><td>{{ element.nm_tag_rfid }}</td><td>{{ element.nm_chave }}</td><td> {{element.cd_tipo_item!=7?(element.qt_us==1?element.cd_item_u:(element.cd_item_u - element.qt_us + (element.cd_tipo_item==3?0:1))):(element.cd_item_u)}}</td><td>{{ element.nm_observacao }}</td><td><DxButton icon="close" type="warning" text="" @click="remove_ativo(element.cd_ativo, element.cd_item_u)"/></td><td>{{ element.cd_ativo }}</td>
                        </tr>
                    </table>
                </div>
                <div class="space_tabela" v-show="show_infos_ativo">
                    <span class="span_p_sonda">Descrição:          </span>{{ ativo_selecionado.nm_descricao }}<br>
                    <span class="span_p_sonda">Número de série:    </span>{{ ativo_selecionado.nm_serial_number }}<br>
                    <span class="span_p_sonda">Chave:              </span>{{ ativo_selecionado.nm_chave }} <br>
                    <span class="span_p_sonda">Fábricante:         </span>{{ ativo_selecionado.nm_fabricante }}<br>
                    <span class="span_p_sonda">Quantidade de Us:   </span>{{ ativo_selecionado.qt_us }}<br>
                    <span class="span_p_sonda">Cliente:            </span>{{ ativo_selecionado.nm_cliente }} <br>
                    <span class="span_p_sonda">Proprietário:       </span>{{ ativo_selecionado.nm_proprietario }} <br>
                    <span class="span_p_sonda">Data de instalação: </span>{{ ativo_selecionado.dt_instalacao }} <br>
                    <span class="span_p_sonda">Mudança:            </span>{{ ativo_selecionado.cd_mudanca }} <br>
                    <span class="span_p_sonda">Observação:         </span>{{ ativo_selecionado.nm_observacao }} <br>
                </div>
                <div class="space_tabela">
                    <DxSelectBox
                        style="width: 500px;"
                        v-if="ativo_selecionado.cd_tipo_item == 4 || ativo_selecionado.cd_tipo_item == 6"
                        placeholder="Ativos para Chassi"
                        :data-source="ativos_select"
                        v-model="cd_ativo_lamina"
                        display-expr="nm_item_serial"
                        value-expr="cd_ativo"
                        search-mode="contains"
                        search-expr="nm_item_serial"
                        :search-enabled="true"
                        @value-changed="onChangeLamina"
                    />
                    <DxNumberBox
                        v-if="ativo_selecionado.cd_tipo_item == 4 || ativo_selecionado.cd_tipo_item == 6"
                        placeholder="Posição inicial"
                        v-model="cd_item_u"
                        :show-spin-buttons="true"
                        :show-clear-button="true"
                        :min="0"
                    />
                    <br>
                    <DxButton 
                        v-if="ativo_lamina"
                        icon="lock"
                        text="Posicionar"
                        @click="posicionar_lamina"/>
                </div>
            </div>
        </div>
        <br>
        <hr class="rounded">
        <br>
        <DxButton
            icon="verticalaligntop" 
            type="default" 
            class="button_popup"
            text="Visualizar Rack" 
            @click="mostra_rack"/>
        <DxButton 
            class="button_popup"
            icon="add" 
            type="default" 
            text="Adicionar ativo"
            @click="add_ativo"/>
        <DxButton 
            class="button_popup"
            icon="trash" 
            type="warning" 
            text="Remover ativo"
            @click="remove_ativo(ativo_selecionado.cd_ativo, ativo_selecionado.cd_item_u)"/>
    </div>
</template>
<script>
import DxButton from 'devextreme-vue/button'
import DxSelectBox from 'devextreme-vue/select-box';
import api from '@/api/api'
import { DxNumberBox } from 'devextreme-vue/number-box';
//import ativos_info from './ativo_selecionado_sonda'
import notify from 'devextreme/ui/notify'

    export default{
        name:'something_else',
        props:{
            ativo_pai: Object
        },
        data(){
            return{
                ativos_hack: [],
                laminas_rack: [],
                posicoes: [],
                load: false,
                ativo_selecionado: {},
                ativo_p: {},
                show_rack: false,
                show_add_ativo: false,
                cd_item_u: 0,
                cd_ativo: 0,
                show_infos_ativo: false,
                position: { x: 975, y: 200 },
                size: { width: 25, height: 100 },
                dragging: false,
                resizing: false,
                dragOffset: { x: 0, y: 0 },
                startSize: { width: 0, height: 0 },
                startMouse: { x: 0, y: 0 },
                ativo_lamina: null,
                cd_ativo_lamina: 0,
                ativos: []
            }
        },
        async mounted(){
            await this.carrega_dados()
        },
        methods:{
            startDrag(e) {
              if (e.target.classList.contains('resize-handle')) return;
              e.preventDefault();
              this.dragging = true;
              this.dragOffset.x = e.clientX - this.position.x;
              this.dragOffset.y = e.clientY - this.position.y;
              document.addEventListener('mousemove', this.onDrag);
              document.addEventListener('mouseup', this.stopDrag);
            },
            onDrag(e) {
              if (!this.dragging) return;
              this.position.x = e.clientX - this.dragOffset.x;
              this.position.y = e.clientY - this.dragOffset.y;
            },
            stopDrag() {
              this.dragging = false;
              document.removeEventListener('mousemove', this.onDrag);
              document.removeEventListener('mouseup', this.stopDrag);
            },
            startResize(e) {
              this.resizing = true;
              this.startSize = { ...this.size };
              this.startMouse = { x: e.clientX, y: e.clientY };
              document.addEventListener('mousemove', this.onResize);
              document.addEventListener('mouseup', this.stopResize);
            },
            onResize(e) {
              if (!this.resizing) return;
              const dx = e.clientX - this.startMouse.x;
              const dy = e.clientY - this.startMouse.y;
              this.size.width = this.startSize.width + dx;
              this.size.height = this.startSize.height + dy;
            },
            stopResize() {
              this.resizing = false;
              document.removeEventListener('mousemove', this.onResize);
              document.removeEventListener('mouseup', this.stopResize);
            },
            async onChangeLamina(){
                this.ativo_lamina = await api.get('consulta_ativo_item', [this.cd_ativo_lamina])
            },
            async carrega_dados(){
                this.ativo_p = this.ativo_pai
                this.ativos_select = await api.get('consulta_ativo_sem_pai', [])
                this.ativos = await api.get('consulta_ativos_filho', [this.ativo_pai.cd_ativo])
                this.mostra_rack()
            },
            async onChangeAtivo(){
                this.ativo_selecionado = await api.get('consulta_ativo_item', [this.cd_ativo])
                console.log('ATIVO', this.ativo_selecionado[0])
                this.ativo_selecionado = this.ativo_selecionado[0]
                this.show_infos_ativo = true
            },
            async remove_ativo(cd_ativo_remove, cd_item_u){

                var result = await api.get('remove_ativo_posicao_vertical', [cd_ativo_remove, cd_item_u, this.ativo_pai.cd_ativo])
                if (result.Code == 0 || result.code == 0) {
                    notify({ message: result.Message, type: 'success', displayTime: 3500, animation: { show: { type: 'fade', duration: 400, from: 0, to: 1, }, hide: { type: 'fade', duration: 40, to: 0 }, }, }, { position: 'bottom center' })
                }
                if (result.Code == 1 || result.code == 1) {
                    notify({ message: result.Message, type: 'error', displayTime: 3500, animation: { show: { type: 'fade', duration: 400, from: 0, to: 1, }, hide: { type: 'fade', duration: 40, to: 0 }, }, }, { position: 'bottom center' })
                }
                this.show_infos_ativo = false
            },
            add_ativo(){
                this.show_rack = false
                this.show_add_ativo = true
                this.ativo_selecionado = {}
            },
            async mostra_rack(){
                this.ativos = await api.get('consulta_ativos_filho', [this.ativo_pai.cd_ativo])
                this.valida_ativo()
                this.show_rack = true
                this.show_add_ativo = false
                this.ativo_selecionado = {}
            },
            valida_ativo(){
                this.posicoes = []
                this.ativos_hack = []
                this.ativo_selecionado = {}
                this.laminas_rack = []
                this.ativo_lamina = null
                for(var i = 1; i <= this.ativo_pai.qt_us; i++){
                    this.posicoes.push(i)
                    var item = this.ativos.filter((a)=> a.cd_item_u == i && a.cd_tipo_item != 3 &&  a.cd_tipo_item != 7)
                    console.log('ITEM', item)
                    if(item.length != 0){
                        this.ativos_hack.push(item[0])
                    }
                    else{
                        this.ativos_hack.push({u:i})
                    }
                }
                this.laminas_rack = this.ativos.filter((a) => a.cd_tipo_item == 3 || a.cd_tipo_item == 7)
                //this.ativos_hack = this.ativos_hack.filter((este, id)=> this.ativos_hack.indexOf(este)===id);
                this.ativos_hack.reverse()
                this.posicoes.reverse()
                this.ativos.sort((a, b) => a.cd_item_u - b.cd_item_u).reverse()
                console.log('ATIVOS RACK',this.ativos_hack)
                this.load = true
            },
            async adicionar_ativo(){
                var result = await api.get('add_ativo_filho',[this.ativo_pai.cd_ativo, this.cd_ativo, this.cd_item_u])
                if (result.Code == 0 || result.code == 0) {
                    notify({ message: result.Message, type: 'success', displayTime: 3500, animation: { show: { type: 'fade', duration: 400, from: 0, to: 1, }, hide: { type: 'fade', duration: 40, to: 0 }, }, }, { position: 'bottom center' })
                }
                if (result.Code == 1 || result.code == 1) {
                    notify({ message: result.Message, type: 'error', displayTime: 3500, animation: { show: { type: 'fade', duration: 400, from: 0, to: 1, }, hide: { type: 'fade', duration: 40, to: 0 }, }, }, { position: 'bottom center' })
                }
                this.valida_ativo()
            },
            async click_ativo(ativo){
                this.ativo_selecionado = ativo
                console.log(ativo)
                this.cd_item_u = (ativo.cd_item_u - (ativo.qt_us-1))
                this.show_infos_ativo = true
                //POSICIONAR LÂMINA
            },
            async posicionar_lamina(){
                var json = {
                    'size':this.size,
                    'position':this.position,
                    'ativo': this.ativo_lamina[0].cd_ativo,
                    'ativo_pai' : this.ativo_pai.cd_ativo,
                    'ativo_selecionado' : this.ativo_selecionado.cd_ativo,
                    'cd_item_u' : this.cd_item_u
                }
                var result = await api.post('posicionar_lamina', json)
                if (result.Code == 0 || result.code == 0) {
                    notify({ message: result.Message, type: 'success', displayTime: 3500, animation: { show: { type: 'fade', duration: 400, from: 0, to: 1, }, hide: { type: 'fade', duration: 40, to: 0 }, }, }, { position: 'bottom center' })
                }
                if (result.Code == 1 || result.code == 1) {
                    notify({ message: result.Message, type: 'error', displayTime: 3500, animation: { show: { type: 'fade', duration: 400, from: 0, to: 1, }, hide: { type: 'fade', duration: 40, to: 0 }, }, }, { position: 'bottom center' })
                }
                this.laminas_rack.push(this.ativo_lamina[0])
                this.ativos = await api.get('consulta_ativos_filho', [this.ativo_pai.cd_ativo])
                this.valida_ativo();
            }
        },
        components:{
            DxButton,
            DxSelectBox,
            DxNumberBox,
            //ativos_info
        }
    }
</script>
<style>
.space_tabela{
    margin-left: 25px;
}
td{
    padding-left:12px;
    padding-right:12px;
}
tr:nth-child(even){background-color: #f2f2f2}
th {
  padding: 12px;
  text-align: left;
  background-color: #2E5AFB;
  color: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
table {
  border-collapse: collapse;
}
.div-rack{
    display: flex;
    position: relative;
}
.divs{
    display: flex;
    flex-wrap: wrap;

}
.infos_ativo{
  display: flex;
  align-items: center;
}
.span_p{
  color: rgb(0, 0, 0);
  font-weight: bold;
}
.rack_num {
    height: 15px;
    border-top: 0.5px solid black;
    border-bottom: 0.5px solid black;
    text-align: right;
}
.racknum{
    margin-top: 25px;
    width: 30px;
}
.rack {
    margin-top: 20px;
    border: 5px solid gray;
    width: 180px;
}
.rack_item {
    height: 15px;
    width: 180px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: end;
}

.rack_item_imagem{
  height: 15px;
  width: 180px;
}

hr.rounded {
  border-top: 3px solid #1185B2;
  border-radius: 3px;
}

.button_popup{
    width: 17%;
}
.draggable {
  position: fixed;
  cursor: move;
  user-select: none;
  box-sizing: border-box;
  z-index: 9999;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}


.resize-handle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background-color: #59ff00;
  cursor: se-resize;
}
</style>